import { Link } from 'react-router-dom';
import { hotTopics } from '@/mocks/site';
import { getChannel } from '@/mocks/channels';
import { toneClasses } from '@/components/feature/ChannelPill';

export default function HotRanking() {
  const list = hotTopics.slice(0, 6);
  const topHeat = list[0]?.up || 1;

  return (
    <section className="flex h-full flex-col rounded-lg border border-background-200/70 bg-background-50">
      <div className="flex items-center justify-between border-b border-background-200/70 px-4 py-3.5 md:px-5">
        <h2 className="flex items-center gap-2 text-base font-bold text-foreground-950">
          <span className="inline-flex h-7 items-center gap-1 rounded-full bg-primary-600 px-2.5 text-xs font-bold text-background-50">
            <i className="ri-fire-fill" aria-hidden="true" /> HOT
          </span>
          实时热搜榜
        </h2>
        <span className="text-xs text-foreground-400">按热度实时更新</span>
      </div>
      <ol className="flex-1 px-2 py-1 md:px-3">
        {list.map((t, i) => {
          const channel = getChannel(t.categorySlug);
          return (
            <li key={t.title} className="group">
              <Link
                to={`/channel/${t.categorySlug}`}
                className="flex items-center gap-3 rounded-md px-2 py-2.5 transition-colors hover:bg-background-100"
              >
                <span
                  className={`inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-md text-xs font-bold ${
                    i < 3
                      ? 'bg-primary-600 text-background-50'
                      : 'bg-secondary-100 text-secondary-700'
                  }`}
                >
                  {i + 1}
                </span>
                <div className="min-w-0 flex-1">
                  <p className="truncate text-sm font-medium text-foreground-800 group-hover:text-primary-700">
                    {t.title}
                  </p>
                  <p className="text-xs text-foreground-400">{channel?.name}</p>
                </div>
                <div className="shrink-0 text-right">
                  <span className="block text-xs font-semibold text-foreground-700">{t.heat}</span>
                  <span
                    className={`inline-flex items-center gap-0.5 text-xs ${
                      t.up > 0 ? 'text-primary-500' : 'text-foreground-400'
                    }`}
                  >
                    <i className={t.up > 0 ? 'ri-arrow-up-line' : 'ri-arrow-down-line'} aria-hidden="true" />
                    {t.up}%
                  </span>
                </div>
              </Link>
            </li>
          );
        })}
      </ol>
      <div className="border-t border-background-200/70 p-3">
        <Link
          to="/channel/shehui"
          className={`inline-flex w-full items-center justify-center gap-1 rounded-md border px-3 py-2 text-sm font-medium transition-colors hover:brightness-95 ${toneClasses(
            'secondary',
          )}`}
        >
          查看更多话题 <i className="ri-arrow-right-line" aria-hidden="true" />
        </Link>
      </div>
    </section>
  );
}